<script>
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import 'prismjs/themes/prism.css';
    import 'prismjs/themes/prism-coy.css';
    import { api_host } from "../../stores.js";
    import { getToken, doFetch } from "../../utils/Fetching.js";
    import { toast_message } from '../../utils/toast_message.js';
    import { Highlight } from "svelte-highlight";
    import typescript from "svelte-highlight/languages/typescript";
    import "svelte-highlight/styles/github.css";


    let is_busy = false;
    let is_mounted = false;
    let api_key = '';
    let domain_name = '';
    let open_new_tab = false;
    $: embed_code = `<script src="https://${domain_name}/embed_script.js"><\/script>
<iframe
    id="houseofyardsIframe"
    data-newtab=${open_new_tab}
    src="https://${domain_name}/embed?key=${api_key}"
    style="width: 100%; height: 80px; border: 0px;"
></iframe>`;
    $: {
        console.log(embed_code);
    }
    $: content_title = "Contents - Address Search Box";

    const { auth_type, auth_token, domain_code } = getToken();

    function openNewTabChanged(e) {
        open_new_tab = e.target.checked;
    }

    onMount(async () => {
        setTimeout(() => { is_mounted = true;}, 250);

        const res = await doFetch(
            api_host + '/api/landscaper/get/embed_api_key',
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
        );

        if (res.status) {
            api_key = res.api_key;
            domain_name = res.domain_name;
        } else {
            toast_message(false, res.msg || 'Failed', 3000);
        }
    });
</script>


<Header bind:title={content_title} bind:is_busy={is_busy} />
<div class="contentholder">
    <div class="pagenote">
        <p>The embed address search box code is several lines of code that you need to paste into each webpage if you want the instant price quote address search bar appears on your own website.</p>
        <p>To add the address search box to your webpages, copy the entire contents of the text box below. {'Paste it after the opening <head> tag on each page.'}</p>
        <p><strong>Note:</strong> You don't need to use this code on your <span style="color: blue;">{domain_name}</span> website which already has the address search box.</p>
    </div>
    <div class="section embed_code">
        <div class="sectionsubtitle">Your address search box code</div>
        <Highlight language={typescript} code={embed_code} />
    </div>

    <div class="d-flex flex-row justify-center align-center">
        <input 
            style="width: 12px;"
            id="newtab" 
            type="checkbox" 
            checked={open_new_tab}
            on:change={(e) => {openNewTabChanged(e);}}
            disabled={is_busy}
        />  
        <span class="pl-2">Open new tab</span>
    </div>
    <div class="buttonholder">
        <button on:click={()=>{
            navigator.clipboard.writeText(embed_code);
            toast_message(true, 'Address Search Box Code Copied', 1000);
        }}>Copy</button>
    </div>
</div>


<style>
    p {
        margin-bottom: 0.5rem;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    :global(.embed_code > pre::before) {
        display: none!important;
    }
    :global(.embed_code > pre::after) {
        display: none!important;
    }
    .contentholder {
        padding: 0px;
    }
    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        padding-left: 25px;
        padding-right: 25px;
        background-color: #357a38;
        color: white;
    }
    :global(.flatpickr-input) {
        width: 250px;
    }
    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.flatpickr-input) {
            width: 100%;
        }
        :global(.toolsholder .group) {
            padding-left: 0px;
            padding-right: 0px;
        }
        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }
    }
</style>